import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ArrowDownIcon = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'm' : _b, strokeWidth = _a.strokeWidth;
    if (size === 'm') {
        return (jsxs("svg", __assign({ className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Arrow down" }), jsx("path", { d: "M19 10L12 15L5 10", stroke: "currentColor", strokeWidth: strokeWidth || 1.5, strokeMiterlimit: "10" })] })));
    }
    return (jsxs("svg", __assign({ className: className, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Arrow down" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.03955 5.18403L1.96046 4L6.00001 7.14187L10.0396 4L10.9605 5.18403L6.00001 9.04216L1.03955 5.18403Z", fill: "#484C51" })] })));
};

export { ArrowDownIcon };
